export const LIST_USER_REQ = "LIST_USER_REQ";
export const LIST_USER_SUCCESS = "LIST_USER_SUCCESS";
export const LIST_USER_FAILED = "LIST_USER_FAILED";
